(function() {
    $('input:radio[name=external]').change(function(){
    	if (this.value !=='External'){
            $('#vendor-section').css('display','none');
		} else {
            $('#vendor-section').css('display','block');
		}
	});

	if($('#part_vendor_id').length) {
		//Initially
		loadPreviousVendor();

		//On change
		$("#part_vendor_id").change(function(){
			showVendor();
		});
	}
})();

function showVendor(){
	var id = $('#part_vendor_id').val();
	$('#prev_vendor_id').val(id);
	$('#vendor-info').html('').load(api_prefix + 'vendors/' + id);
}

function loadPreviousVendor(){
	var id = $('#prev_vendor_id').val();
    $('#vendor-info').html('').load(api_prefix + 'vendors/' + id);
}
